const services = {
  header: {
    create: 'Criar',
  },

  toast: {
    error: {
      badResponse: '[Service] resposta inválida do servidor',
      create: {},
      edit: {},
    },
    success: {
      create: {
        body: 'O serviço foi adicionado com sucesso',
      },
      delete: {
        body: 'Os serviços foram excluídos com sucesso',
      },
      edit: {},
    },
  },
  headerButtons: {
    create: 'Novo',
    delete: 'Remover',
  },
  table: {
    actions: {
      delete: 'Remover',
      export: 'Exportar',
    },
    headers: {
      maxPassengers: 'Máximo de passageiros',
      sharedWith: 'Compartilhado com',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  create: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível criar serviço',
    },
    successToast: {
      message: 'sucesso! Serviço criado com sucesso',
    },
  },

  edit: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível atualizar o serviço',
    },
    successToast: {
      message: 'sucesso! Serviço atualizado com sucesso',
    },
  },

  delete: {
    errorToast: {
      message: 'Ocorreu um erro. Não foi possível excluir o serviço',
    },
    successToast: {
      message: 'sucesso! O serviço foi excluído com sucesso',
    },
  },

  forms: {
    header: {
      createService: {
        title: 'Criar',
      },

      updateService: {
        title: 'Atualizar',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Enviar',
        update: 'Enviar',
      },
    },

    information: {
      details: {
        header: 'Detalhes',
        fields: {
          name: 'Nome',
          type: 'Tipo',
          maxPassengers: 'Máximo de passageiros',
          shared: 'Compartilhado com',
          availableCount: 'Número de veículos',
          penaltyScore: {
            title: 'Pontuação de penalidade',
            description: 'Despesa de aluguel do veículo em comparação com a duração extra da rota, medida em minutos.',
          },
        },
      },
      actions: {
        header: 'Ações',
        buttons: {
          delete: 'Remover',
          resetPassword: 'Redefinir Senha',
        },
      },
    },
  },

  serviceTypes: {
    private: 'Privado',
    shared: 'Compartilhado',
  },
};

export default services;
